import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Layout,
	ThemeName,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import {
	ArrowLeft,
	CarPickupService,
	FleetServicePrivate,
	Magnifier,
} from 'src/icons-core-imports';

import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useFeatureAppConfig } from 'src/feature-app';
import { Filtros, isMyDealerServiceAvailable } from 'src/feature-app/NewMap';
import { NewMap } from 'src/feature-app/NewMap/components/Map';
import { useMapGeneralController } from 'src/feature-app/NewMap/MapGeneralController';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { CloseAndAnteriorCTA } from 'src/feature-app/Screen';
import { Points, SelectedTab } from 'src/types';
import {
	FilterButton,
	FiltrosWrapperLayer,
	handleClickCarPickup,
	handleClickReplacementCar,
	ListWrapper,
	MapAndTabsWrapper,
	SmallerSVG,
} from '.';

interface ViewCitaPosventaProps {
	handleSeleccionarOnClick: any;
	handleShowSlots?: (point: Points) => string | null;
	renderPoints(
		points: any,
		carPickupSelected?: boolean,
		replacementCarSelected?: boolean,
		isTime?: boolean,
	): JSX.Element[];
	renderCalendar?(): JSX.Element;
	showCalendar?: boolean;
	preSelectedOrderValue?: SelectedTab;
	setPreSelectedOrderValue?: React.Dispatch<
		React.SetStateAction<SelectedTab>
	>;
	pointsToList: Points[];
	services?: boolean;
	paddingBottomList?: string;
	isPosventa?: boolean;
	concesionario?: boolean;
	onlySuggest?: boolean;
	theme?: ThemeName;
}

export const LayerDesktopView = (props: ViewCitaPosventaProps) => {
	const {
		renderPoints,
		renderCalendar,
		showCalendar,
		preSelectedOrderValue,
		setPreSelectedOrderValue,
		pointsToList,
		services,
		paddingBottomList,
		isPosventa,
		concesionario,
		onlySuggest,
		theme,
	} = props;

	const [showFiltros, setShowFiltros] = useState<boolean>(false);
	const [preselectedDealerForm, setPreselectedDealerForm] = useState(false);
	const config = useFeatureAppConfig();
	const sustitucionRef = useRef(null);
	const recogidaRef = useRef(null);

	useEffect(() => {
		if (config.trigger === 'cita-posventa-dealer') {
			setPreselectedDealerForm(true);
		} else {
			setPreselectedDealerForm(false);
		}
	}, []);

	const { searchIsDealer } = useMapGeneralController();
	const { handleAreYouSureLayer } = useOneFormContext();

	const handleShowFiltros = () => {
		setShowFiltros(!showFiltros);
	};

	//seleccionar los que tiene coche de sustitucion o servicio de recogida

	const [carPickupSelected, setCarPickupSelected] = useState<boolean>(false);
	const [replacementCarSelected, setReplacementCarSelected] =
		useState<boolean>(false);

	return showCalendar ? (
		renderCalendar()
	) : (
		<ThemeProvider theme={theme ? theme : 'inverted'}>
			<MapAndTabsWrapper
				className="map-tabs-wrapper"
				showFilters={showFiltros}
			>
				<div className="wrapper wrapper--tabs">
					<CloseAndAnteriorCTA closeInMap />
					{services ? (
						<Container
							horizontalAlign={'flex-start'}
							gutter={ContainerGutter.static200}
							padding={{
								left: ContainerPadding.static450,
								bottom: ContainerPadding.static200,
							}}
						>
							<SmallerSVG>
								<CTA
									ref={sustitucionRef}
									tag="button"
									emphasis={
										replacementCarSelected
											? 'primary'
											: 'secondary'
									}
									size="small"
									onClick={e => {
										e.preventDefault();
										handleClickReplacementCar(
											replacementCarSelected,
											setReplacementCarSelected,
										);
										sustitucionRef.current.blur();
									}}
									icon={<FleetServicePrivate />}
									aria-label="Coche de sustitución"
								>
									Coche de sustitución
								</CTA>
							</SmallerSVG>
							<SmallerSVG>
								<CTA
									ref={recogidaRef}
									tag="button"
									emphasis={
										carPickupSelected
											? 'primary'
											: 'secondary'
									}
									size="small"
									onClick={e => {
										e.preventDefault();
										handleClickCarPickup(
											carPickupSelected,
											setCarPickupSelected,
										);
										recogidaRef.current.blur();
									}}
									icon={<CarPickupService />}
									aria-label="Servicio de recogida y entrega"
								>
									Servicio de recogida y entrega
								</CTA>
							</SmallerSVG>
						</Container>
					) : null}
					<Container horizontalAlign={'center'} stretchContent={true}>
						<div style={{ width: '100%' }}>
							{pointsToList ? (
								<Layout
									appearance={{
										[Breakpoints.default]: [
											{ name: '.', columns: 2 },
											{ name: 'a', columns: 20 },
											{ name: '.', columns: 2 },
										],
									}}
								>
									<ListWrapper
										className="wrapper--list"
										paddingBottom={paddingBottomList}
									>
										{renderPoints(
											pointsToList,
											carPickupSelected,
											replacementCarSelected,
										)}
									</ListWrapper>
								</Layout>
							) : null}
						</div>
					</Container>
				</div>
				<div className="wrapper wrapper--map">
					<NewMap
						searchIsDealer={searchIsDealer}
						preSelectedOrderValue={preSelectedOrderValue}
						preselectedDealerForm={preselectedDealerForm}
						carPickupSelected={carPickupSelected}
						replacementCarSelected={replacementCarSelected}
						isPosventa={isPosventa}
					/>
					{preselectedDealerForm ||
					isMyDealerServiceAvailable() ? null : (
						<FilterButton className="filtros-navbar">
							<ThemeProvider theme="main">
								<CTA
									tag="button"
									emphasis="secondary"
									size="small"
									onClick={e => {
										e.preventDefault();
										handleShowFiltros();
									}}
									icon={<Magnifier variant="small" />}
									aria-label="Buscar de nuevo"
								>
									Buscar de nuevo
								</CTA>
							</ThemeProvider>
						</FilterButton>
					)}
				</div>
				<div
					className="opacity-layer"
					onClick={() => setShowFiltros(false)}
				/>
			</MapAndTabsWrapper>

			<CSSTransition in={showFiltros} timeout={300} classNames="filtros">
				<FiltrosWrapperLayer className="filtros-wrapper">
					<ThemeProvider theme="main">
						<div className="back-btn">
							<CTA
								tag="button"
								emphasis="tertiary"
								size="small"
								onClick={(e: any) => {
									e.preventDefault();
									handleShowFiltros();
								}}
								icon={<ArrowLeft />}
								aria-label="Atrás"
							/>
						</div>
						<Filtros
							closeFiltros={() => handleShowFiltros()}
							showFiltros={showFiltros}
							setShowFiltros={setShowFiltros}
							setPreSelectedOrderValue={setPreSelectedOrderValue}
							preSelectedOrderValue={preSelectedOrderValue}
							citaPosventa={isPosventa}
							onlySuggest={true}
							concesionario={true}
						/>
					</ThemeProvider>
				</FiltrosWrapperLayer>
			</CSSTransition>
		</ThemeProvider>
	);
};
